// extracted by mini-css-extract-plugin
export default {"message":"error-message_message__zNm6G","closeButton":"error-message_closeButton__OkIeS","messageText":"error-message_messageText__qcK6z"};